module.exports = __webpack_public_path__ + "static/img/iphoneX.b2e996e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/iphoneX.png
// module id = RXvg
// module chunks = 1